import { type FormEvent, useRef, useState } from 'react';
import type { Language } from '../i18n';
import { type FieldErrors, validateForm } from '../lib/form-validation';
import { feedbackCopy } from '../studio-feedback-copy';

export function useLocalizedForm(language: Language) {
  const [errors, setErrors] = useState<FieldErrors>({});
  const attempted = useRef(false);
  const copy = feedbackCopy[language];

  function validate(form: HTMLFormElement) {
    attempted.current = true;
    const next = validateForm(form);
    setErrors(next);
    const first = Object.keys(next)[0];
    if (first) {
      const field = form.elements.namedItem(first);
      if (field instanceof HTMLElement) field.focus();
      return false;
    }
    return true;
  }

  function onInput(event: FormEvent<HTMLFormElement>) {
    if (attempted.current) setErrors(validateForm(event.currentTarget));
  }

  function errorFor(name: string) {
    const error = errors[name];
    return error ? copy[error.code].replace('{limit}', String(error.limit ?? '')) : '';
  }

  function reset() { attempted.current = false; setErrors({}); }
  return { errors, validate, onInput, errorFor, reset, summary: copy.summary };
}

export function FormFieldError({ id, message }: { id: string; message: string }) {
  return message ? <span id={id} className="studio-field-error">{message}</span> : null;
}
